export default "__VITE_ASSET__BFtH5iB3__"